// @flow
import React from "react"
import ProductList from "components/ProductList"
import Mobile from "components/Media/Mobile"
import Desktop from "components/Media/Desktop"
import Tabs from "components/Tabs"
import Description from "components/Description"
import Loader from "components/Loader"
import { PageTitle, FieldTitle } from "componentsStyled/Typography/Titles"
import { Text } from "componentsStyled/Typography/Texts"
import { Container, HPaddedFullWidthContainer } from "componentsStyled/Layout/Containers"
import type { AffiliateFull } from "data/affiliate/types"
import type { ProductOffering } from "data/product/types"
import type { Manufacturer } from "data/manufacturer/types"
import Info from "./Info"
import Contacts from "./Contacts"
import ImageGallery from "./ImageGallery"
import { getImages } from "./ImageGallery/helpers"
import { Split, Left, Right } from "./styled"

type Props = {|
  loadingMore: boolean,
  affiliate: AffiliateFull,
  productOfferings: ProductOffering[],
  manufacturers: Manufacturer[],
|}

const Content = ({ affiliate, productOfferings, loadingMore }: Props) => {
  const tabs = {
    inventory: (
      <React.Fragment>
        <ProductList productOfferings={productOfferings} />
        <Loader hide={!loadingMore} pb0 />
      </React.Fragment>
    ),
    "Store description": (
      <HPaddedFullWidthContainer>
        <Text lh={2.6}>{affiliate.description}</Text>
        <Contacts affiliate={affiliate} />
      </HPaddedFullWidthContainer>
    ),
  }

  return (
    <React.Fragment>
      <Desktop>
        <Container>
          <PageTitle>{affiliate.name}</PageTitle>
          <Split>
            <Left>
              <ImageGallery
                items={getImages(affiliate.images)}
                showIndex={true}
                infinite={false}
                showNav={true}
                showBullets={false}
                showThumbnails={true}
                showFullscreenButton={false}
                showPlayButton={false}
                thumbnailPosition="bottom"
              />
            </Left>
            <Right>
              <FieldTitle>About</FieldTitle>
              <Description description={affiliate.description} />
              <Info affiliate={affiliate} />
              <Contacts affiliate={affiliate} />
            </Right>
          </Split>
          <ProductList productOfferings={productOfferings} />
          <Loader hide={!loadingMore} pb0 />
        </Container>
      </Desktop>
      <Mobile>
        <ImageGallery
          items={getImages(affiliate.images)}
          showIndex={true}
          infinite={false}
          showNav={false}
          showBullets={true}
          showThumbnails={true}
          showFullscreenButton={false}
          showPlayButton={false}
          thumbnailPosition="bottom"
        />
        <HPaddedFullWidthContainer>
          <Info affiliate={affiliate} />
        </HPaddedFullWidthContainer>
        <Tabs startingIndex={0} tabs={tabs} limitSwitchWidth />
      </Mobile>
    </React.Fragment>
  )
}

export default Content



// WEBPACK FOOTER //
// ./src/pages/Affiliate/Content/index.js